// extracted by mini-css-extract-plugin
export default {"box":"styles_box__AMmSL","wrapper":"styles_wrapper__2IxpG","svg":"styles_svg__uMNP7","message":"styles_message__CER49","description":"styles_description__v8sin"};